import { create } from "zustand";
import getAssignedOrder from "../api/index";
import { assignedOrderFilterData } from "../api/index";

const useAssignedOrders = create((set) => ({
  customersData: [],
  isLoading: true,
  isError: false,
  paginationData: {},
  fetchAssignedOrderData: async (pageNumber) => {
    set({ isLoading: true });
    try {
      set({ isLoading: true });
      const response = await getAssignedOrder(pageNumber);
      set({
        customersData: response.data.data,
        paginationData: response.data.pagination,
        isLoading: false,
      });
    } catch (error) {
      set({ isError: true, data: [], isLoading: false });
    }
  },
  fetchAssignedOrderFilterData: async (queryParams) => {
    set({ isLoading: true });
    try {
      const response = await assignedOrderFilterData(queryParams);
      set({
        customersData: response.data.data,
        paginationData: response.data.pagination,
        isLoading: false,
      });
    } catch (error) {
      set({ isError: true, data: [], isLoading: false });
    }
  },
}));

export default useAssignedOrders;
